import { effect, inject, Injectable, signal } from "@angular/core";
import { ConfigurationAlert, ConfigurationAlertType, JsonReply } from "@grupo-constant/next-dtype/types";
import { map, Observable } from "rxjs";
import { USER_URI } from "../projects.service";
import { ChangePremisesLinkStatusRequest, CreateDocumentWeeklyWorkRequest, DailyTask, DailyTaskActivity, DeletePremisesCenterActivityCategoryListRequest, DeletePremisesCenterBaseListRequest, DeletePremisesContactRequest, DeletePremisesGenericContactRequest, DeletePremisesHotelClosingConceptRequest, DeletePremisesHotelOccupancyEventsRequest, DeletePremisesHotelRoomCatalogRequest, DeletePremisesHotelShiftListRequest, DeletePremisesHotelTipListRequest, FlushDailyTaskDataReply, FlushDailyTaskDataRequest, FlushDailyTaskReply, FlushDailyTaskRequest, ValidateDailyTaskReply, ValidateDailyTaskCustomRequest, ValidateDailyTaskWorkedRequest, FlushPremisesActivityTypeOrderRequest, FlushPremisesCenterActivityCategoryReply, FlushPremisesCenterActivityCategoryRequest, FlushPremisesCenterActivityRequest, FlushPremisesCenterBaseReply, FlushPremisesCenterBaseRequest, FlushPremisesCenterGeneralReply, FlushPremisesCenterGeneralRequest, FlushPremisesContactRequest, FlushPremisesGenericActivityTypeReply, FlushPremisesGenericActivityTypeRequest, FlushPremisesGenericContactReply, FlushPremisesGenericContactRequest, FlushPremisesGenericGroupsReply, FlushPremisesGenericGroupsRequest, FlushPremisesGenericShiftReply, FlushPremisesGenericShiftRequest, FlushPremisesGenericWorkRealizedConceptRequest, FlushPremisesHotelActivityGeneralReply, FlushPremisesHotelActivityGeneralRequest, FlushPremisesHotelActivityReply, FlushPremisesHotelActivityRequest, FlushPremisesHotelClosingConceptReply, FlushPremisesHotelClosingConceptRequest, FlushPremisesHotelContactReply, FlushPremisesHotelDailyOccupancyReply, FlushPremisesHotelDailyOccupancyRequest, FlushPremisesHotelGeneralReply, FlushPremisesHotelGeneralRequest, FlushPremisesHotelOccupancyYearlyEventsReply as FlushPremisesHotelOccupancyEventsReply, FlushPremisesHotelOccupancyYearlyEventsRequest as FlushPremisesHotelOccupancyEventsRequest, FlushPremisesHotelOccupancyYearlyReply, FlushPremisesHotelOccupancyYearlyRequest, FlushPremisesHotelRatioReply, FlushPremisesHotelRatioRequest, FlushPremisesHotelRoomCatalogReply, FlushPremisesHotelRoomCatalogRequest, FlushPremisesHotelShiftReply, FlushPremisesHotelShiftRequest, FlushPremisesHotelTipReply, FlushPremisesHotelTipRequest, FlushPremisesHotelWorkCustomClosingConceptDataReply, FlushPremisesHotelWorkCustomClosingConceptDataRequest, FlushPremisesWorkClientRemarksRequest, GenerateDocumentPremisesHotelWorkReply, GenerateDocumentPremisesHotelWorkRequest, GeneratePremisesCenterMagicCodeReply, GeneratePremisesCenterMagicCodeRequest, GeneratePremisesCenterWorkReply, GeneratePremisesHotelMagicCodeReply, GeneratePremisesHotelMagicCodeRequest, GeneratePremisesHotelWorkReply, GeneratePremisesWorkRequest, GenericActivityWorktime, GenericOtherActivity, GenericWorkRatioActivity, PremisesAllocationScope, PremisesCenterWork, PremisesGenericActivityType, PremisesGenericWork, PremisesHotelDaily, PremisesHotelWork, PremisesMeasurementType, PremisesShiftDailyWork, PremisesShiftSchedule, PremisesType, RegenerateDailyTaskDataPeriodRequest, RegenerateDailyTaskDataReply, RegenerateDailyTaskDataRequest, RetrieveBusTargetRatioReply, RetrieveBusTargetRatioRequest, RetrieveDailyTaskDataReply, RetrieveDailyTaskDataRequest, RetrieveMonthlyTotalByNet4Concept4ClientRequest, RetrieveMonthlyTotalByNet4ConceptReply, RetrieveMonthlyTotalByNet4ConceptRequest, RetrievePremisesActivityListRequest as RetrievePremisesActivityTypeListRequest, RetrievePremisesCenterActivityCategoryListReply, RetrievePremisesCenterActivityCategoryListRequest, RetrievePremisesCenterActivityTypeListReply, RetrievePremisesCenterBaseListReply, RetrievePremisesCenterBaseListRequest, RetrievePremisesCenterDailyWorkReply, RetrievePremisesCenterGeneralReply, RetrievePremisesCenterGeneralRequest, RetrievePremisesCenterMonthlyWorkReply, RetrievePremisesCenterNet4ConceptsReply, RetrievePremisesCenterWeeklyWorkReply, RetrievePremisesCenterWorkReply, RetrievePremisesContactListRequest, RetrievePremisesDailyWorkRequest, RetrievePremisesDailyWorkSearchOptionsReply, RetrievePremisesDailyWorkSearchOptionsRequest, RetrievePremisesGenericActivityListReply as RetrievePremisesGenericActivityTypeListReply, RetrievePremisesGenericActivityTypeListRequest, RetrievePremisesGenericContactListReply, RetrievePremisesGenericContactListRequest, RetrievePremisesGenericDailyWorkReply, RetrievePremisesGenericGroupsReply, RetrievePremisesGenericGroupsRequest, RetrievePremisesGenericMonthlyWorkReply, RetrievePremisesGenericNet4ConceptsReply, RetrievePremisesGenericShiftListReply, RetrievePremisesGenericShiftListRequest, RetrievePremisesGenericShiftScheduleListReply, RetrievePremisesGenericShiftScheduleListRequest, RetrievePremisesGenericWeeklyWorkReply, RetrievePremisesGenericWorkReply, RetrievePremisesHotelActivityGeneralReply, RetrievePremisesHotelActivityGeneralRequest, RetrievePremisesHotelActivityListReply, RetrievePremisesHotelClosingConceptListReply, RetrievePremisesHotelClosingConceptListRequest, RetrievePremisesHotelContactListReply, RetrievePremisesHotelDailyWorkReply, RetrievePremisesHotelGeneralReply, RetrievePremisesHotelGeneralRequest, RetrievePremisesHotelMonthlyWorkReply, RetrievePremisesHotelNet4ConceptsReply, RetrievePremisesHotelOccupancyYearlyEventsReply, RetrievePremisesHotelOccupancyYearlyEventsRequest, RetrievePremisesHotelOccupancyYearlyReply, RetrievePremisesHotelOccupancyYearlyRequest, RetrievePremisesHotelRatioReply, RetrievePremisesHotelRatioRequest, RetrievePremisesHotelRoomCatalogListReply, RetrievePremisesHotelRoomCatalogListRequest, RetrievePremisesHotelShiftListReply, RetrievePremisesHotelShiftListRequest, RetrievePremisesHotelShiftScheduleListReply, RetrievePremisesHotelTipListReply, RetrievePremisesHotelTipListRequest, RetrievePremisesHotelWeeklyWorkReply, RetrievePremisesHotelWorkReply, RetrievePremisesLinkListReply, RetrievePremisesLinkListRequest, RetrievePremisesLinkReply, RetrievePremisesLinkRequest, RetrievePremisesMonthlyWork4ClientRequest, RetrievePremisesMonthlyWorkRequest, RetrievePremisesHotelNet4ConceptsRequest as RetrievePremisesNet4ConceptsRequest, RetrievePremisesHotelShiftScheduleListRequest as RetrievePremisesShiftScheduleListRequest, RetrievePremisesWeeklyWorkRequest, RetrievePremisesWorkRequest, SearchPremisesHotelActivityNet4ConceptsReply, SearchPremisesHotelActivityNet4ConceptsRequest, SearchPremisesHotelNet4ConceptsReply, SearchPremisesHotelNet4ConceptsRequest, SendDailyWork2ConnectCoreRequest, SendPremisesCenterWorkReply, SendPremisesGenericWorkReply, SendPremisesHotelWorkReply, SendPremisesHotelWork2ConnectCoreRequest as SendPremisesWork2ConnectCoreRequest, SendPremisesHotelWorkRequest as SendPremisesWorkRequest, SyncMagicBagMinutesReply, SyncMagicBagMinutesRequest, ValidateDailyTaskPlannedRequest, FlushDailyTaskActivityDataRequest, FlushDailyTaskActivityDataReply, ValidateDailyTaskCustomReducedRequest, ValidateDailyTaskCustomReducedListRequest, ValidateDailyTaskCustomReducedReply, ValidateDailyTaskCustomReducedListReply, RetrievePremisesWorkplaceBillingAutomationConfigRequest, RetrievePremisesWorkplaceBillingAutomationConfigReply, FlushDailyTaskListRequest, GenericBillingAutomationGroup, FlushDailyTaskPlannedActivityDataRequest, FlushDailyTaskPlannedActivityDataReply, CleanPremisesGenericNet4ConceptsRequest, ClearPremisesGenericNet4ConceptsReply, CopyDailyTaskPlannedActivitiesRequest, RetrievePremisesGenericActivityTypeObjectiveListRequest, RetrievePremisesGenericActivityTypeObjectiveListReply, FlushPremisesGenericActivityTypeObjectiveRequest, FlushPremisesGenericActivityTypeObjectiveReply, DeletePremisesGenericActivityTypeObjectiveRequest, DownloadWorkRealizedExcelRequest, UploadWorkRealizedExcelRequest, UploadWorkRealizedExcelReply, CopyDailyTaskPlanningToFutureRequest, PremisesGenericActivityTypeObjectiveListUpdate, PremisesGenericActivityTypeObjective } from "./premises.types";
import { FormControl, FormGroup } from "@angular/forms";
import { format, parse } from "date-fns";
import { TranslocoService } from "@ngneat/transloco";
import { HttpService } from "../../../../core/http/http.service";
import { StorageKeysEnum } from "../../../../core/enums/storage.keys.enum";
import { NextMethodsEnum } from "../../../../core/enums/next-methods.enum";
import { WebSocketMessage, WebSocketTypeEnum } from "../../../../core/websocket/websocket.types";

@Injectable({
    providedIn: 'root'
})
export class PremisesServices {

    private _dailyTaskMessage = signal<DailyTask>(undefined);
    readonly dailyTaskMessage = this._dailyTaskMessage.asReadonly();

    private _dailyMessage = signal<PremisesHotelDaily>(undefined);
    readonly dailyMessage = this._dailyMessage.asReadonly();

    private _hotelWorkMessage = signal<PremisesHotelWork>(undefined);
    readonly hotelWorkMessage = this._hotelWorkMessage.asReadonly();

    private _centerWorkMessage = signal<PremisesCenterWork>(undefined);
    readonly centerWorkMessage = this._centerWorkMessage.asReadonly();

    private _genericWorkMessage = signal<PremisesGenericWork>(undefined);
    readonly genericWorkMessage = this._genericWorkMessage.asReadonly();

    private _genericActivityTypeObjectiveListMessage = signal<PremisesGenericActivityTypeObjectiveListUpdate>(undefined);
    readonly genericActivityTypeObjectiveListMessage = this._genericActivityTypeObjectiveListMessage.asReadonly();

    private _activityFilters = signal(new Map<string, { activityFilter: string, groupFilter: string, categoryFilter: string, billingAutomation: string, showTheorics: boolean, showJustified: boolean }>());
    readonly activityFilters = this._activityFilters.asReadonly();

    private http = inject(HttpService);
    private transloco = inject(TranslocoService);

    constructor() {
        const activityFiltersString = localStorage.getItem(StorageKeysEnum.genericActivitiesFilter);
        if (activityFiltersString) {
            this._activityFilters.set(new Map(Object.entries(JSON.parse(activityFiltersString))));
        }

        effect(() => {
            localStorage.setItem(StorageKeysEnum.genericActivitiesFilter, JSON.stringify(Object.fromEntries(this._activityFilters())));
        });
    }

    setActivityFilters(premisesId: string, activityFilter: string, groupFilter: string, categoryFilter: string, billingAutomation: string, showTheorics: boolean, showJustified?: boolean) {
        this._activityFilters.update(map => {
            showJustified = showJustified ?? map.get(premisesId)?.showJustified ?? true;
            billingAutomation = billingAutomation ?? map.get(premisesId)?.billingAutomation ?? '';
            map.set(premisesId, { activityFilter, groupFilter, categoryFilter, billingAutomation, showTheorics, showJustified });
            return new Map(map);
        });
    }

    getSchedule(shift: PremisesShiftDailyWork, activities: DailyTaskActivity[]) {
        let schedule: PremisesShiftSchedule | undefined;
        const actNames = activities.map(a => a.activity);
        if (actNames.length > 0) {
            const filteredSchedules = shift.schedules?.filter(s => s.activityName?.some(act => actNames.includes(act))) ?? [];
            schedule = this.getBestSchedule(filteredSchedules);
        }
        if (schedule === undefined) {
            schedule = this.getBestSchedule(shift.schedules ?? []);
        }
        return schedule;
    }

    private getBestSchedule(schedules: PremisesShiftSchedule[]) {
        let schedule: PremisesShiftSchedule | undefined;
        for (const s of schedules) {
            if (s.isDefault) {
                return s;
            } else if (schedule === undefined) {
                schedule = s;
            } else {
                if (schedule.fromTime) {
                    if (s.fromTime) {
                        if (s.fromTime < schedule.fromTime) {
                            schedule = s;
                        }
                    } else if (s.toTime) {
                        schedule = s;
                    }
                } else if (schedule.toTime) {
                    if (s.toTime) {
                        if (s.toTime > schedule.toTime) {
                            schedule = s;
                        }
                    }
                }
            }
        }
        return schedule;
    }

    getScheduleLabel(sch: PremisesShiftSchedule): string {
        if (sch.name) {
            return sch.name;
        }

        return sch.fromTime && sch.toTime
            ? this.transloco.translate('taskList.fromTimeToTime', { startTime: format(parse(sch.fromTime, 'HH:mm:ss', new Date()), 'HH:mm'), toTime: format(parse(sch.toTime, 'HH:mm:ss', new Date()), 'HH:mm') })
            : sch.fromTime
            ? this.transloco.translate('taskList.startAt', { time: format(parse(sch.fromTime, 'HH:mm:ss', new Date()), 'HH:mm') })
            : this.transloco.translate('taskList.exitAt',  { time: format(parse(sch.toTime, 'HH:mm:ss', new Date()), 'HH:mm') });
    }

    getAlertType(alert: ConfigurationAlert[]) {
        if (alert?.some(a => a.type === ConfigurationAlertType.ERROR)) {
            return ConfigurationAlertType.ERROR;
        } else if (alert?.some(a => a.type === ConfigurationAlertType.WARNING)) {
            return ConfigurationAlertType.WARNING;
        } else if (alert?.some(a => a.type === ConfigurationAlertType.INFO)) {
            return ConfigurationAlertType.INFO;
        }
    }

    getGoalPlannedPercentage(objective: PremisesGenericActivityTypeObjective) {
        return Math.round(((objective.plannedGoal ?? 0) / objective.goal * 100) * 100) / 100;
    }

    getMinGoalPlannedPercentage(objective: PremisesGenericActivityTypeObjective) {
        return Math.round(((objective.plannedGoal ?? 0) / objective.minGoal * 100) * 100) / 100;
    }

    getGoalRealPercentage(objective: PremisesGenericActivityTypeObjective) {
        return Math.round(((objective.realGoal ?? 0) / objective.goal * 100) * 100) / 100;
    }

    getMinGoalRealPercentage(objective: PremisesGenericActivityTypeObjective) {
        return Math.round(((objective.realGoal ?? 0) / objective.minGoal * 100) * 100) / 100;
    }

    getPlannedGoalColor(objective: PremisesGenericActivityTypeObjective) {
        if (objective.minGoal !== undefined) {
            const minGoalPlannedPercentage = this.getMinGoalPlannedPercentage(objective);
            if (minGoalPlannedPercentage < 50) {
                return 'text-red-500';
            } else if (minGoalPlannedPercentage < 90) {
                return 'text-orange-500';
            } else {
                return 'text-green-500';
            }
        } else if (objective.goal !== undefined) {
            const goalPlannedPercentage = this.getGoalPlannedPercentage(objective);
            if (goalPlannedPercentage < 50) {
                return 'text-red-500';
            } else if (goalPlannedPercentage < 90) {
                return 'text-orange-500';
            } else {
                return 'text-green-500';
            }
        }
        return 'text-green-500';
    }

    getRealGoalColor(objective: PremisesGenericActivityTypeObjective) {
        if (objective.minGoal !== undefined) {
            const minGoalPlannedPercentage = this.getMinGoalRealPercentage(objective);
            if (minGoalPlannedPercentage < 50) {
                return 'text-red-500';
            } else if (minGoalPlannedPercentage < 90) {
                return 'text-orange-500';
            } else {
                return 'text-green-500';
            }
        } else if (objective.goal !== undefined) {
            const goalPlannedPercentage = this.getGoalRealPercentage(objective);
            if (goalPlannedPercentage < 50) {
                return 'text-red-500';
            } else if (goalPlannedPercentage < 90) {
                return 'text-orange-500';
            } else {
                return 'text-green-500';
            }
        }
        return 'text-green-500';
    }

    retrievePremisesLinkList(request: RetrievePremisesLinkListRequest) {
        return this.http.post<RetrievePremisesLinkListReply>(NextMethodsEnum.retrievePremisesLinkList, request);
    }

    retrievePremisesLink(request: RetrievePremisesLinkRequest) {
        return this.http.post<RetrievePremisesLinkReply>(NextMethodsEnum.retrievePremisesLink, request);
    }

    changePremisesLinkStatus(request: ChangePremisesLinkStatusRequest) {
        return this.http.post<JsonReply>(NextMethodsEnum.changePremisesLinkStatus, request);
    }

    retrievePremisesCenterGeneral(request: RetrievePremisesCenterGeneralRequest) {
        return this.http.post<RetrievePremisesCenterGeneralReply>(NextMethodsEnum.retrievePremisesCenterGeneral, request);
    }

    retrievePremisesHotelGeneral(request: RetrievePremisesHotelGeneralRequest) {
        return this.http.post<RetrievePremisesHotelGeneralReply>(NextMethodsEnum.retrievePremisesHotelGeneral, request);
    }

    flushPremisesCenterGeneral(request: FlushPremisesCenterGeneralRequest) {
        return this.http.post<FlushPremisesCenterGeneralReply>(NextMethodsEnum.flushPremisesCenterGeneral, request);
    }

    flushPremisesHotelGeneral(request: FlushPremisesHotelGeneralRequest) {
        return this.http.post<FlushPremisesHotelGeneralReply>(NextMethodsEnum.flushPremisesHotelGeneral, request);
    }

    retrievePremisesHotelOccupancyYearly(request: RetrievePremisesHotelOccupancyYearlyRequest) {
        return this.http.post<RetrievePremisesHotelOccupancyYearlyReply>(NextMethodsEnum.retrievePremisesHotelOccupancyYearly, request);
    }

    flushPremisesHotelOccupancyYearly(request: FlushPremisesHotelOccupancyYearlyRequest) {
        return this.http.post<FlushPremisesHotelOccupancyYearlyReply>(NextMethodsEnum.flushPremisesHotelOccupancyYearly, request);
    }

    retrievePremisesHotelOccupancyYearlyEvents(request: RetrievePremisesHotelOccupancyYearlyEventsRequest) {
        return this.http.post<RetrievePremisesHotelOccupancyYearlyEventsReply>(NextMethodsEnum.retrievePremisesHotelOccupancyEvents, request);
    }

    flushPremisesHotelOccupancyYearlyEvents(request: FlushPremisesHotelOccupancyEventsRequest) {
        return this.http.post<FlushPremisesHotelOccupancyEventsReply>(NextMethodsEnum.flushPremisesHotelOccupancyEvents, request);
    }

    deletePremisesHotelOccupancyEvents(request: DeletePremisesHotelOccupancyEventsRequest) {
        return this.http.post<JsonReply>(NextMethodsEnum.deletePremisesHotelOccupancyEvents, request);
    }

    retrievePremisesHotelRatio(request: RetrievePremisesHotelRatioRequest) {
        return this.http.post<RetrievePremisesHotelRatioReply>(NextMethodsEnum.retrievePremisesHotelRatio, request);
    }

    flushPremisesHotelRatio(request: FlushPremisesHotelRatioRequest) {
        return this.http.post<FlushPremisesHotelRatioReply>(NextMethodsEnum.flushPremisesHotelRatio, request);
    }

    retrievePremisesCenterNet4Concepts(request: RetrievePremisesNet4ConceptsRequest) {
        return this.http.post<RetrievePremisesCenterNet4ConceptsReply>(NextMethodsEnum.retrievePremisesCenterNet4Concepts, request);
    }

    retrievePremisesHotelNet4Concepts(request: RetrievePremisesNet4ConceptsRequest) {
        return this.http.post<RetrievePremisesHotelNet4ConceptsReply>(NextMethodsEnum.retrievePremisesHotelNet4Concepts, request);
    }

    searchPremisesHotelNet4Concepts(request: SearchPremisesHotelNet4ConceptsRequest) {
        return this.http.post<SearchPremisesHotelNet4ConceptsReply>(NextMethodsEnum.searchPremisesHotelNet4Concepts, request).pipe(map(reply => reply?.net4Concepts ?? []));
    }

    searchPremisesHotelActivityNet4Concepts(request: SearchPremisesHotelActivityNet4ConceptsRequest) {
        return this.http.post<SearchPremisesHotelActivityNet4ConceptsReply>(NextMethodsEnum.searchPremisesHotelActivityNet4Concepts, request).pipe(map(reply => reply?.net4Concepts ?? []));
    }

    retrievePremisesHotelRoomCatalogList(request: RetrievePremisesHotelRoomCatalogListRequest) {
        return this.http.post<RetrievePremisesHotelRoomCatalogListReply>(NextMethodsEnum.retrievePremisesHotelRoomCatalogList, request);
    }

    flushPremisesHotelRoomCatalog(request: FlushPremisesHotelRoomCatalogRequest) {
        return this.http.post<FlushPremisesHotelRoomCatalogReply>(NextMethodsEnum.flushPremisesHotelRoomCatalog, request);
    }

    deletePremisesHotelRoomCatalogList(request: DeletePremisesHotelRoomCatalogRequest) {
        return this.http.post<JsonReply>(NextMethodsEnum.deletePremisesHotelRoomCatalogList, request);
    }

    retrievePremisesCenterActivityTypeList(request: RetrievePremisesActivityTypeListRequest) {
        return this.http.post<RetrievePremisesCenterActivityTypeListReply>(NextMethodsEnum.retrievePremisesCenterActivityTypeList, request);
    }

    retrievePremisesHotelActivityList(request: RetrievePremisesActivityTypeListRequest) {
        return this.http.post<RetrievePremisesHotelActivityListReply>(NextMethodsEnum.retrievePremisesHotelActivityList, request);
    }

    flushPremisesCenterActivity(request: FlushPremisesCenterActivityRequest) {
        return this.http.post<FlushPremisesHotelActivityReply>(NextMethodsEnum.flushPremisesCenterActivity, request);
    }

    flushPremisesHotelActivity(request: FlushPremisesHotelActivityRequest) {
        return this.http.post<FlushPremisesHotelActivityReply>(NextMethodsEnum.flushPremisesHotelActivity, request);
    }

    retrievePremisesHotelActivityGeneral(request: RetrievePremisesHotelActivityGeneralRequest) {
        return this.http.post<RetrievePremisesHotelActivityGeneralReply>(NextMethodsEnum.retrievePremisesHotelActivityGeneral, request);
    }

    flushPremisesHotelActivityGeneral(request: FlushPremisesHotelActivityGeneralRequest) {
        return this.http.post<FlushPremisesHotelActivityGeneralReply>(NextMethodsEnum.flushPremisesHotelActivityGeneral, request);
    }

    retrievePremisesCenterBaseList(request: RetrievePremisesCenterBaseListRequest) {
        return this.http.post<RetrievePremisesCenterBaseListReply>(NextMethodsEnum.retrievePremisesCenterBaseList, request);
    }

    flushPremisesCenterBase(request: FlushPremisesCenterBaseRequest) {
        return this.http.post<FlushPremisesCenterBaseReply>(NextMethodsEnum.flushPremisesCenterBase, request);
    }

    deletePremisesCenterBaseList(request: DeletePremisesCenterBaseListRequest) {
        return this.http.post<JsonReply>(NextMethodsEnum.deletePremisesCenterBaseList, request);
    }

    retrievePremisesCenterActivityCategoryList(request: RetrievePremisesCenterActivityCategoryListRequest) {
        return this.http.post<RetrievePremisesCenterActivityCategoryListReply>(NextMethodsEnum.retrievePremisesCenterActivityCategoryList, request);
    }

    flushPremisesCenterActivityCategory(request: FlushPremisesCenterActivityCategoryRequest) {
        return this.http.post<FlushPremisesCenterActivityCategoryReply>(NextMethodsEnum.flushPremisesCenterActivityCategory, request);
    }

    deletePremisesCenterActivityCategoryList(request: DeletePremisesCenterActivityCategoryListRequest) {
        return this.http.post<JsonReply>(NextMethodsEnum.deletePremisesCenterActivityCategoryList, request);
    }

    retrievePremisesHotelTipList(request: RetrievePremisesHotelTipListRequest) {
        return this.http.post<RetrievePremisesHotelTipListReply>(NextMethodsEnum.retrievePremisesHotelTipList, request);
    }

    flushPremisesHotelTip(request: FlushPremisesHotelTipRequest) {
        return this.http.post<FlushPremisesHotelTipReply>(NextMethodsEnum.flushPremisesHotelTip, request);
    }

    deletePremisesHotelTipList(request: DeletePremisesHotelTipListRequest) {
        return this.http.post<JsonReply>(NextMethodsEnum.deletePremisesHotelTipList, request);
    }

    retrievePremisesShiftList(premiseType: PremisesType, request: RetrievePremisesHotelShiftListRequest | RetrievePremisesGenericShiftListRequest): Observable<RetrievePremisesHotelShiftListReply | RetrievePremisesGenericShiftListReply> {
        switch (premiseType) {
            case PremisesType.HOTEL:
                return this.http.post<RetrievePremisesHotelShiftListReply>(NextMethodsEnum.retrievePremisesHotelShiftList, request);
            case PremisesType.CENTER:
                return this.http.post<RetrievePremisesHotelShiftListReply>(NextMethodsEnum.retrievePremisesCenterShiftList, request);
            case PremisesType.LOGISTIC_CENTER:
                return this.http.post<RetrievePremisesGenericShiftListReply>(NextMethodsEnum.retrievePremisesGenericShiftList, request)
        }
    }

    flushPremisesShift(premiseType: PremisesType, request: FlushPremisesHotelShiftRequest | FlushPremisesGenericShiftRequest): Observable<FlushPremisesHotelShiftReply | FlushPremisesGenericShiftReply> {
        switch (premiseType) {
            case PremisesType.HOTEL:
                return this.http.post<FlushPremisesHotelShiftReply>(NextMethodsEnum.flushPremisesHotelShift, request);
            case PremisesType.CENTER:
                return this.http.post<FlushPremisesHotelShiftReply>(NextMethodsEnum.flushPremisesCenterShift, request);
            case PremisesType.LOGISTIC_CENTER:
                return this.http.post<FlushPremisesGenericShiftReply>(NextMethodsEnum.flushPremisesGenericShift, request);
        }
    }

    deletePremisesShiftList(premiseType: PremisesType, request: DeletePremisesHotelShiftListRequest) {
        switch (premiseType) {
            case PremisesType.HOTEL:
                return this.http.post<JsonReply>(NextMethodsEnum.deletePremisesHotelShiftList, request);
            case PremisesType.CENTER:
                return this.http.post<JsonReply>(NextMethodsEnum.deletePremisesCenterShiftList, request);
            case PremisesType.LOGISTIC_CENTER:
                return this.http.post<JsonReply>(NextMethodsEnum.deletePremisesGenericShiftList, request);
        }
    }

    retrievePremisesShiftScheduleList(premiseType: PremisesType, request: RetrievePremisesShiftScheduleListRequest | RetrievePremisesGenericShiftScheduleListRequest): Observable<RetrievePremisesHotelShiftScheduleListReply | RetrievePremisesGenericShiftScheduleListReply> {
        switch (premiseType) {
            case PremisesType.HOTEL:
                return this.http.post<RetrievePremisesHotelShiftScheduleListReply>(NextMethodsEnum.retrievePremisesHotelShiftScheduleList, request);
            case PremisesType.CENTER:
                return this.http.post<RetrievePremisesHotelShiftScheduleListReply>(NextMethodsEnum.retrievePremisesCenterShiftScheduleList, request);
            case PremisesType.LOGISTIC_CENTER:
                return this.http.post<RetrievePremisesGenericShiftScheduleListReply>(NextMethodsEnum.retrievePremisesGenericShiftScheduleList, request);
        }
    }

    retrievePremisesHotelDailyWork(request: RetrievePremisesDailyWorkRequest) {
        return this.http.post<RetrievePremisesHotelDailyWorkReply>(NextMethodsEnum.retrievePremisesDailyWork, request);
    }

    retrievePremisesCenterDailyWork(request: RetrievePremisesDailyWorkRequest) {
        return this.http.post<RetrievePremisesCenterDailyWorkReply>(NextMethodsEnum.retrievePremisesDailyWork, request);
    }

    retrievePremisesGenericDailyWork(request: RetrievePremisesDailyWorkRequest) {
        return this.http.post<RetrievePremisesGenericDailyWorkReply>(NextMethodsEnum.retrievePremisesDailyWork, request);
    }

    flushPremisesHotelDailyOccupancy(request: FlushPremisesHotelDailyOccupancyRequest) {
        return this.http.post<FlushPremisesHotelDailyOccupancyReply>(NextMethodsEnum.flushPremisesHotelDailyOccupancy, request);
    }

    retrievePremisesDailyWorkSearchOptions(request: RetrievePremisesDailyWorkSearchOptionsRequest) {
        return this.http.post<RetrievePremisesDailyWorkSearchOptionsReply>(NextMethodsEnum.retrievePremisesDailyWorkSearchOptions, request);
    }

    retrievePremisesHotelWeeklyWork(request: RetrievePremisesWeeklyWorkRequest) {
        return this.http.post<RetrievePremisesHotelWeeklyWorkReply>(NextMethodsEnum.retrievePremisesWeeklyWork, request)
            .pipe(map(reply => {
                for (const daily of reply?.daily ?? []) {
                    if (daily.plannedRatio) {
                        daily.plannedRatio = Math.round((daily.plannedRatio + Number.EPSILON) * 100) / 100;
                    }
                    if (daily.ratio) {
                        daily.ratio = Math.round((daily.ratio + Number.EPSILON) * 100) / 100;
                    }
                }
                return reply;
            }));
    }

    retrievePremisesCenterWeeklyWork(request: RetrievePremisesWeeklyWorkRequest) {
        return this.http.post<RetrievePremisesCenterWeeklyWorkReply>(NextMethodsEnum.retrievePremisesWeeklyWork, request);
    }

    retrievePremisesGenericWeeklyWork(request: RetrievePremisesWeeklyWorkRequest) {
        return this.http.post<RetrievePremisesGenericWeeklyWorkReply>(NextMethodsEnum.retrievePremisesWeeklyWork, request);
    }

    flushDailyTask(request: FlushDailyTaskRequest) {
        return this.http.post<FlushDailyTaskReply>(NextMethodsEnum.flushDailyTask, request);
    }

    retrievePremisesHotelClosingConceptList(request: RetrievePremisesHotelClosingConceptListRequest) {
        return this.http.post<RetrievePremisesHotelClosingConceptListReply>(NextMethodsEnum.retrievePremisesHotelClosingConceptList, request);
    }

    flushPremisesHotelClosingConcept(request: FlushPremisesHotelClosingConceptRequest) {
        return this.http.post<FlushPremisesHotelClosingConceptReply>(NextMethodsEnum.flushPremisesHotelClosingConcept, request);
    }

    deletePremisesHotelClosingConcept(request: DeletePremisesHotelClosingConceptRequest) {
        return this.http.post<JsonReply>(NextMethodsEnum.deletePremisesHotelClosingConcept, request);
    }

    generatePremisesHotelMagicCode(request: GeneratePremisesHotelMagicCodeRequest) {
        return this.http.post<GeneratePremisesHotelMagicCodeReply>(NextMethodsEnum.generatePremisesHotelMagicCode, request);
    }

    generatePremisesCenterMagicCode(request: GeneratePremisesCenterMagicCodeRequest) {
        return this.http.post<GeneratePremisesCenterMagicCodeReply>(NextMethodsEnum.generatePremisesCenterMagicCode, request);
    }

    retrieveDailyTaskData(request: RetrieveDailyTaskDataRequest) {
        return this.http.post<RetrieveDailyTaskDataReply>(NextMethodsEnum.retrieveDailyTaskData, request);
    }

    flushDailyTaskData(request: FlushDailyTaskDataRequest) {
        return this.http.post<FlushDailyTaskDataReply>(NextMethodsEnum.flushDailyTaskData, request);
    }

    regenerateDailyTaskData(request: RegenerateDailyTaskDataRequest) {
        return this.http.post<RegenerateDailyTaskDataReply>(NextMethodsEnum.regenerateDailyTaskData, request);
    }

    retrievePremisesContactList(premiseType: PremisesType, request: RetrievePremisesContactListRequest | RetrievePremisesGenericContactListRequest) {
        switch (premiseType) {
            case PremisesType.CENTER:
                return this.http.post<RetrievePremisesHotelContactListReply>(NextMethodsEnum.retrievePremisesCenterContactList, request);
            case PremisesType.HOTEL:
                return this.http.post<RetrievePremisesHotelContactListReply>(NextMethodsEnum.retrievePremisesHotelContactList, request);
            case PremisesType.LOGISTIC_CENTER:
                return this.http.post<RetrievePremisesGenericContactListReply>(NextMethodsEnum.retrievePremisesGenericContactList, request);
        }
    }

    flushPremisesContact(premiseType: PremisesType, request: FlushPremisesContactRequest | FlushPremisesGenericContactRequest): Observable<FlushPremisesHotelContactReply | FlushPremisesGenericContactReply> {
        switch (premiseType) {
            case PremisesType.CENTER:
                return this.http.post<FlushPremisesHotelContactReply>(NextMethodsEnum.flushPremisesCenterContact, request);
            case PremisesType.HOTEL:
                return this.http.post<FlushPremisesHotelContactReply>(NextMethodsEnum.flushPremisesHotelContact, request);
            case PremisesType.LOGISTIC_CENTER:
                return this.http.post<FlushPremisesGenericContactReply>(NextMethodsEnum.flushPremisesGenericContact, request);
        }
    }

    deletePremisesContact(premiseType: PremisesType, request: DeletePremisesContactRequest | DeletePremisesGenericContactRequest) {
        switch (premiseType) {
            case PremisesType.CENTER:
                return this.http.post<JsonReply>(NextMethodsEnum.deletePremisesCenterContact, request);
            case PremisesType.HOTEL:
                return this.http.post<JsonReply>(NextMethodsEnum.deletePremisesHotelContact, request);
            case PremisesType.LOGISTIC_CENTER:
                return this.http.post<JsonReply>(NextMethodsEnum.deletePremisesGenericContact, request)
        }
    }

    retrievePremisesCenterWork(request: RetrievePremisesWorkRequest) {
        return this.http.post<RetrievePremisesCenterWorkReply>(NextMethodsEnum.retrievePremisesCenterWork, request)
            .pipe(map(reply => {
                for (const status of reply?.centerWorkStatus ?? []) {
                    if (status.userId) {
                        status.displayName = reply.partaker?.[USER_URI]?.[status.userId]?.displayName;
                        status.sAMAccountName = reply.partaker?.[USER_URI]?.[status.userId]?.sAMAccountName;
                    }
                }
                return reply;
            }));
    }

    retrievePremisesGenericWork(request: RetrievePremisesWorkRequest) {
        return this.http.post<RetrievePremisesGenericWorkReply>(NextMethodsEnum.retrievePremisesGenericWork, request)
            .pipe(map(reply => {
                for (const status of reply?.genericWorkStatus ?? []) {
                    if (status.userId) {
                        status.displayName = reply.partaker?.[USER_URI]?.[status.userId]?.displayName;
                        status.sAMAccountName = reply.partaker?.[USER_URI]?.[status.userId]?.sAMAccountName;
                    }
                }
                return reply;
            }));
    }

    retrievePremisesHotelWork(request: RetrievePremisesWorkRequest) {
        return this.http.post<RetrievePremisesHotelWorkReply>(NextMethodsEnum.retrievePremisesHotelWork, request)
            .pipe(map(reply => {
                for (const status of reply?.hotelWorkStatus ?? []) {
                    if (status.userId) {
                        status.displayName = reply.partaker?.[USER_URI]?.[status.userId]?.displayName;
                        status.sAMAccountName = reply.partaker?.[USER_URI]?.[status.userId]?.sAMAccountName;
                    }
                }
                return reply;
            }));
    }

    generateDocumentPremisesHotelWork(request: GenerateDocumentPremisesHotelWorkRequest) {
        return this.http.post<GenerateDocumentPremisesHotelWorkReply>(NextMethodsEnum.generateDocumentPremisesHotelWork, request)
            .pipe(map(reply => {
                for (const status of reply?.hotelWorkStatus ?? []) {
                    if (status.userId) {
                        status.displayName = reply.partaker?.[USER_URI]?.[status.userId]?.displayName;
                        status.sAMAccountName = reply.partaker?.[USER_URI]?.[status.userId]?.sAMAccountName;
                    }
                }
                return reply;
            }));
    }

    generatePremisesCenterWork(request: GeneratePremisesWorkRequest) {
        return this.http.post<GeneratePremisesCenterWorkReply>(NextMethodsEnum.generatePremisesCenterWork, request)
            .pipe(map(reply => {
                for (const status of reply?.centerWorkStatus ?? []) {
                    if (status.userId) {
                        status.displayName = reply.partaker?.[USER_URI]?.[status.userId]?.displayName;
                        status.sAMAccountName = reply.partaker?.[USER_URI]?.[status.userId]?.sAMAccountName;
                    }
                }
                return reply;
            }));
    }

    generatePremisesGenericWork(request: GeneratePremisesWorkRequest) {
        return this.http.post<GeneratePremisesCenterWorkReply>(NextMethodsEnum.generatePremisesGenericWork, request)
            .pipe(map(reply => {
                for (const status of reply?.genericWorkStatus ?? []) {
                    if (status.userId) {
                        status.displayName = reply.partaker?.[USER_URI]?.[status.userId]?.displayName;
                        status.sAMAccountName = reply.partaker?.[USER_URI]?.[status.userId]?.sAMAccountName;
                    }
                }
                return reply;
            }));
    }

    generatePremisesHotelWork(request: GeneratePremisesWorkRequest) {
        return this.http.post<GeneratePremisesHotelWorkReply>(NextMethodsEnum.generatePremisesHotelWork, request)
            .pipe(map(reply => {
                for (const status of reply?.hotelWorkStatus ?? []) {
                    if (status.userId) {
                        status.displayName = reply.partaker?.[USER_URI]?.[status.userId]?.displayName;
                        status.sAMAccountName = reply.partaker?.[USER_URI]?.[status.userId]?.sAMAccountName;
                    }
                }
                return reply;
            }));
    }

    sendPremisesCenterWork(request: SendPremisesWorkRequest) {
        return this.http.post<SendPremisesCenterWorkReply>(NextMethodsEnum.sendPremisesCenterWork, request)
            .pipe(map(reply => {
                for (const status of reply?.centerWorkStatus ?? []) {
                    if (status.userId) {
                        status.displayName = reply.partaker?.[USER_URI]?.[status.userId]?.displayName;
                        status.sAMAccountName = reply.partaker?.[USER_URI]?.[status.userId]?.sAMAccountName;
                    }
                }
                return reply;
            }));
    }

    sendPremisesGenericWork(request: SendPremisesWorkRequest) {
        return this.http.post<SendPremisesGenericWorkReply>(NextMethodsEnum.sendPremisesGenericWork, request)
            .pipe(map(reply => {
                for (const status of reply?.genericWorkStatus ?? []) {
                    if (status.userId) {
                        status.displayName = reply.partaker?.[USER_URI]?.[status.userId]?.displayName;
                        status.sAMAccountName = reply.partaker?.[USER_URI]?.[status.userId]?.sAMAccountName;
                    }
                }
                return reply;
            }));
    }

    sendPremisesHotelWork(request: SendPremisesWorkRequest) {
        return this.http.post<SendPremisesHotelWorkReply>(NextMethodsEnum.sendPremisesHotelWork, request)
            .pipe(map(reply => {
                for (const status of reply?.hotelWorkStatus ?? []) {
                    if (status.userId) {
                        status.displayName = reply.partaker?.[USER_URI]?.[status.userId]?.displayName;
                        status.sAMAccountName = reply.partaker?.[USER_URI]?.[status.userId]?.sAMAccountName;
                    }
                }
                return reply;
            }));
    }

    flushPremisesCenterWorkClientRemarks(request: FlushPremisesWorkClientRemarksRequest) {
        return this.http.post<JsonReply>(NextMethodsEnum.flushPremisesCenterWorkClientRemarks, request);
    }

    flushPremisesGenericWorkClientRemarks(request: FlushPremisesWorkClientRemarksRequest) {
        return this.http.post<JsonReply>(NextMethodsEnum.flushPremisesGenericWorkClientRemarks, request);
    }

    flushPremisesHotelWorkClientRemarks(request: FlushPremisesWorkClientRemarksRequest) {
        return this.http.post<JsonReply>(NextMethodsEnum.flushPremisesHotelWorkClientRemarks, request);
    }

    flushPremisesHotelWorkCustomClosingConceptData(request: FlushPremisesHotelWorkCustomClosingConceptDataRequest) {
        return this.http.post<FlushPremisesHotelWorkCustomClosingConceptDataReply>(NextMethodsEnum.flushPremisesHotelWorkCustomClosingConceptData, request)
            .pipe(map(reply => {
                for (const status of reply?.hotelWorkStatus ?? []) {
                    if (status.userId) {
                        status.displayName = reply.partaker?.[USER_URI]?.[status.userId]?.displayName;
                        status.sAMAccountName = reply.partaker?.[USER_URI]?.[status.userId]?.sAMAccountName;
                    }
                }
                return reply;
            }));
    }

    regenerateDailyTaskDataPeriod(request: RegenerateDailyTaskDataPeriodRequest) {
        return this.http.post<JsonReply>(NextMethodsEnum.regenerateDailyTaskDataPeriod, request);
    }

    retrievePremisesCenterMonthlyWork(request: RetrievePremisesMonthlyWorkRequest) {
        return this.http.post<RetrievePremisesCenterMonthlyWorkReply>(NextMethodsEnum.retrievePremisesMonthlyWork, request);
    }

    retrievePremisesGenericMonthlyWork(request: RetrievePremisesMonthlyWorkRequest) {
        return this.http.post<RetrievePremisesGenericMonthlyWorkReply>(NextMethodsEnum.retrievePremisesMonthlyWork, request);
    }

    retrievePremisesHotelMonthlyWork(request: RetrievePremisesMonthlyWorkRequest) {
        return this.http.post<RetrievePremisesHotelMonthlyWorkReply>(NextMethodsEnum.retrievePremisesMonthlyWork, request);
    }

    retrievePremisesMonthlyWork4Client(request: RetrievePremisesMonthlyWork4ClientRequest) {
        return this.http.post<RetrievePremisesHotelMonthlyWorkReply>(NextMethodsEnum.retrievePremisesMonthlyWork4Client, request);
    }

    createDocumentWeeklyWork(request: CreateDocumentWeeklyWorkRequest) {
        return this.http.post(NextMethodsEnum.createDocumentWeeklyWork, request, 'blob');
    }

    sendDailyWork2ConnectCore(request: SendDailyWork2ConnectCoreRequest) {
        return this.http.post(NextMethodsEnum.sendDailyWork2ConnectCore, request);
    }

    sendPremisesCenterWork2ConnectCore(request: SendPremisesWork2ConnectCoreRequest) {
        return this.http.post<JsonReply>(NextMethodsEnum.sendPremisesCenterWork2ConnectCore, request);
    }

    sendPremisesGenericWork2ConnectCore(request: SendPremisesWork2ConnectCoreRequest) {
        return this.http.post<JsonReply>(NextMethodsEnum.sendPremisesGenericWork2ConnectCore, request);
    }

    sendPremisesHotelWork2ConnectCore(request: SendPremisesWork2ConnectCoreRequest) {
        return this.http.post<JsonReply>(NextMethodsEnum.sendPremisesHotelWork2ConnectCore, request);
    }

    retrieveBusTargetRatio(request: RetrieveBusTargetRatioRequest) {
        return this.http.post<RetrieveBusTargetRatioReply>(NextMethodsEnum.retrieveBusTargetRatio, request);
    }

    retrieveMonthlyTotalByNet4Concept(request: RetrieveMonthlyTotalByNet4ConceptRequest) {
        return this.http.post<RetrieveMonthlyTotalByNet4ConceptReply>(NextMethodsEnum.retrieveMonthlyTotalByNet4Concept, request)
            .pipe(map(reply => reply?.totalByNet4Concept ?? []));
    }

    retrieveMonthlyTotalByNet4Concept4Client(request: RetrieveMonthlyTotalByNet4Concept4ClientRequest) {
        return this.http.post<RetrieveMonthlyTotalByNet4ConceptReply>(NextMethodsEnum.retrieveMonthlyTotalByNet4Concept4Client, request)
            .pipe(map(reply => reply?.totalByNet4Concept ?? []));
    }

    validateDailyTaskCustom(request: ValidateDailyTaskCustomRequest) {
        return this.http.post<ValidateDailyTaskReply>(NextMethodsEnum.validateDailyTaskCustom, request);
    }

    validateDailyTaskPlanned(request: ValidateDailyTaskPlannedRequest) {
        return this.http.post<ValidateDailyTaskReply>(NextMethodsEnum.validateDailyTaskPlanned, request);
    }

    validateDailyTaskWorked(request: ValidateDailyTaskWorkedRequest) {
        return this.http.post<ValidateDailyTaskReply>(NextMethodsEnum.validateDailyTaskWorked, request);
    }

    syncMagicBagMinutes(request: SyncMagicBagMinutesRequest) {
        return this.http.post<SyncMagicBagMinutesReply>(NextMethodsEnum.syncMagicBagMinutes, request);
    }

    retrievePremisesGenericGroups(request: RetrievePremisesGenericGroupsRequest) {
        return this.http.post<RetrievePremisesGenericGroupsReply>(NextMethodsEnum.retrievePremisesGenericGroups, request);
    }

    flushPremisesGenericGroups(request: FlushPremisesGenericGroupsRequest) {
        return this.http.post<FlushPremisesGenericGroupsReply>(NextMethodsEnum.flushPremisesGenericGroups, request);
    }

    retrievePremisesGenericNet4Concepts(request: RetrievePremisesNet4ConceptsRequest) {
        return this.http.post<RetrievePremisesGenericNet4ConceptsReply>(NextMethodsEnum.retrievePremisesGenericNet4Concepts, request);
    }

    cleanPremisesGenericNet4Concepts(request: CleanPremisesGenericNet4ConceptsRequest) {
        return this.http.post<ClearPremisesGenericNet4ConceptsReply>(NextMethodsEnum.cleanPremisesGenericNet4Concepts, request);
    }
    
    retrievePremisesGenericActivityTypeList(request: RetrievePremisesGenericActivityTypeListRequest) {
        return this.http.post<RetrievePremisesGenericActivityTypeListReply>(NextMethodsEnum.retrievePremisesGenericActivityTypeList, request);
    }

    flushPremisesGenericActivityType(request: FlushPremisesGenericActivityTypeRequest) {
        return this.http.post<FlushPremisesGenericActivityTypeReply>(NextMethodsEnum.flushPremisesGenericActivityType, request);
    }

    flushPremisesActivityTypeOrder(request: FlushPremisesActivityTypeOrderRequest) {
        return this.http.post<JsonReply>(NextMethodsEnum.flushPremisesActivityTypeOrder, request);
    }

    flushPremisesGenericWorkRealizedConcept(request: FlushPremisesGenericWorkRealizedConceptRequest) {
        return this.http.post<JsonReply>(NextMethodsEnum.flushPremisesGenericWorkRealizedConcept, request);
    }

    flushDailyTaskActivityData(request: FlushDailyTaskActivityDataRequest) {
        return this.http.post<FlushDailyTaskActivityDataReply>(NextMethodsEnum.flushDailyTaskActivityData, request);
    }

    validateDailyTaskCustomReduced(request: ValidateDailyTaskCustomReducedRequest) {
        return this.http.post<ValidateDailyTaskCustomReducedReply>(NextMethodsEnum.validateDailyTaskCustomReduced, request);
    }

    validateDailyTaskCustomReducedList(request: ValidateDailyTaskCustomReducedListRequest) {
        return this.http.post<ValidateDailyTaskCustomReducedListReply>(NextMethodsEnum.validateDailyTaskCustomReducedList, request);
    }

    retrievePremisesWorkplaceBillingAutomationConfig(request: RetrievePremisesWorkplaceBillingAutomationConfigRequest) {
        return this.http.post<RetrievePremisesWorkplaceBillingAutomationConfigReply>(NextMethodsEnum.retrievePremisesWorkplaceBillingAutomationConfig, request);
    }

    flushDailyTaskList(request: FlushDailyTaskListRequest) {
        return this.http.post<JsonReply>(NextMethodsEnum.flushDailyTaskList, request);
    }

    flushDailyTaskPlannedActivityData(request: FlushDailyTaskPlannedActivityDataRequest) {
        return this.http.post<FlushDailyTaskPlannedActivityDataReply>(NextMethodsEnum.flushDailyTaskPlannedActivityData, request);
    }

    copyDailyTaskPlannedActivities(request: CopyDailyTaskPlannedActivitiesRequest) {
        return this.http.post<JsonReply>(NextMethodsEnum.copyDailyTaskPlannedActivities, request);
    }

    retrievePremisesGenericActivityTypeObjectiveList(request: RetrievePremisesGenericActivityTypeObjectiveListRequest) {
        return this.http.post<RetrievePremisesGenericActivityTypeObjectiveListReply>(NextMethodsEnum.retrievePremisesGenericActivityTypeObjectiveList, request);
    }

    flushPremisesGenericActivityTypeObjective(request: FlushPremisesGenericActivityTypeObjectiveRequest) {
        return this.http.post<FlushPremisesGenericActivityTypeObjectiveReply>(NextMethodsEnum.flushPremisesGenericActivityTypeObjective, request);
    }

    deletePremisesGenericActivityTypeObjective(request: DeletePremisesGenericActivityTypeObjectiveRequest) {
        return this.http.post<JsonReply>(NextMethodsEnum.deletePremisesGenericActivityTypeObjective, request);
    }
    
    downloadWorkRealizedExcel(request: DownloadWorkRealizedExcelRequest): any {
        return this.http.postWithHeaders<any>(NextMethodsEnum.downloadPremisesGenericWorkRealizedConceptXSSF, request, 'blob');
    }

    uploadWorkRealizedExcel(request: UploadWorkRealizedExcelRequest) {
        return this.http.post<UploadWorkRealizedExcelReply>(NextMethodsEnum.flushDTypeExcelUpload, request);
    }

    copyDailyTaskPlanningToFuture(request: CopyDailyTaskPlanningToFutureRequest) {
        return this.http.post<JsonReply>(NextMethodsEnum.copyDailyTaskPlanningToFuture, request);
    }

    handleWebSocketMessage(message: WebSocketMessage) {
        switch (message.type) {
            case WebSocketTypeEnum.DAILY_TASK_UPDATE:
                this._dailyTaskMessage.set(message.payload);
                break;
            case WebSocketTypeEnum.PREMISES_HOTEL_DAILY_UPDATE:
                this._dailyMessage.set(message.payload);
                break;
            case WebSocketTypeEnum.PREMISES_HOTEL_WORK_UPDATE:
                this._hotelWorkMessage.set(message.payload);
                break;
            case WebSocketTypeEnum.PREMISES_CENTER_WORK_UPDATE:
                this._centerWorkMessage.set(message.payload);
                break;
            case WebSocketTypeEnum.PREMISES_GENERIC_WORK_UPDATE:
                this._genericWorkMessage.set(message.payload);
                break;
            case WebSocketTypeEnum.PREMISES_GENERIC_ACTIVITY_TYPE_OBJECTIVE_LIST_UPDATE:
                this._genericActivityTypeObjectiveListMessage.set(message.payload);
                break;
        }
    }

    createRatioFormGroup(activity: PremisesGenericActivityType, ratioActivity?: GenericWorkRatioActivity, disableRealized = false) {
        const ratioItem = ratioActivity?.items?.length > 0 ? ratioActivity.items[0] : undefined;
        const formGroup = new FormGroup({
            net4ConceptId: new FormControl(activity.net4ConceptId, { nonNullable: true }),
            net4ConceptName: new FormControl(activity.net4ConceptName, { nonNullable: true }),
            displayName: new FormControl(activity.displayName, { nonNullable: true }),
            alternativeName: new FormControl(ratioActivity?.alternativeName ?? null),
            measurementType: new FormControl<PremisesMeasurementType>(activity.measurementType, { nonNullable: true }),
            planned: new FormControl<number | null>({ value: ratioItem?.planned ?? null, disabled: true }),
            realized: new FormControl<boolean | number | null>({ value: ratioItem?.realized ?? null, disabled: activity.allocationScope === PremisesAllocationScope.WORKER || disableRealized }),
            ratio: new FormControl<number | null>({ value: ratioItem?.ratio ?? null, disabled: true }),
            time: new FormControl<number | null>({ value: ratioItem?.time ?? null, disabled: true }),
            goal: new FormControl<number | null>({ value: ratioActivity?.objectiveProgress?.realObjectivePercentage ?? null, disabled: true }),
            minGoal: new FormControl<number | null>({ value: ratioActivity?.objectiveProgress?.realCoveragePercentage ?? null, disabled: true }),
            theoricRatio: new FormControl<number | null>({ value: ratioItem?.theoricRatio ?? null, disabled: true }),
            theoricTime: new FormControl<number | null>({ value: ratioItem?.theoricTime ?? null, disabled: true })
        });
        return formGroup;
    }

    createTimeFormGroup(activity: PremisesGenericActivityType, timeActivity?: GenericActivityWorktime, disableRealized = false) {
        const timeItem = timeActivity?.items?.length > 0 ? timeActivity.items[0] : undefined;
        const formGroup = new FormGroup({
            net4ConceptId: new FormControl(activity.net4ConceptId, { nonNullable: true }),
            net4ConceptName: new FormControl(activity.net4ConceptName, { nonNullable: true }),
            displayName: new FormControl(activity.displayName, { nonNullable: true }),
            alternativeName: new FormControl(timeActivity?.alternativeName ?? null),
            measurementType: new FormControl<PremisesMeasurementType>(activity.measurementType, { nonNullable: true }),
            planned: new FormControl<number | null>({ value: timeItem?.planned ?? null, disabled: true }),
            realized: new FormControl<boolean | number | null>({ value: timeItem?.realized ?? null, disabled: activity.allocationScope === PremisesAllocationScope.WORKER || disableRealized }),
            ratio: new FormControl<number | null>(null),
            time: new FormControl<number | null>({ value: timeItem?.time ?? null, disabled: true }),
            goal: new FormControl<number | null>({ value: timeActivity?.objectiveProgress?.realObjectivePercentage ?? null, disabled: true }),
            minGoal: new FormControl<number | null>({ value: timeActivity?.objectiveProgress?.realCoveragePercentage ?? null, disabled: true }),
            theoricRatio: new FormControl<number | null>({ value: timeItem?.theoricRatio ?? null, disabled: true }),
            theoricTime: new FormControl<number | null>(null)
        });
        return formGroup;
    }

    createOtherFormGroup(activity: PremisesGenericActivityType, otherActivity?: GenericOtherActivity, disableRealized = false) {
        const formGroup = new FormGroup({
            net4ConceptId: new FormControl(activity.net4ConceptId, { nonNullable: true }),
            net4ConceptName: new FormControl(activity.net4ConceptName, { nonNullable: true }),
            displayName: new FormControl(activity.displayName, { nonNullable: true }),
            alternativeName: new FormControl(otherActivity?.alternativeName ?? null),
            measurementType: new FormControl<PremisesMeasurementType>(activity.measurementType, { nonNullable: true }),
            planned: new FormControl<number | null>(null),
            realized: new FormControl<boolean | number | null>({ value: activity.measurementType === PremisesMeasurementType.BOOLEAN && activity.allocationScope === PremisesAllocationScope.CENTER ? otherActivity?.value === 1 : otherActivity?.value, disabled: activity.allocationScope === PremisesAllocationScope.WORKER || disableRealized }),
            ratio: new FormControl<number | null>(null),
            time: new FormControl<number | null>(null),
            goal: new FormControl<number | null>({ value: null, disabled: true }),
            minGoal: new FormControl<number | null>({ value: null, disabled: true }),
            theoricRatio: new FormControl<number | null>(null),
            theoricTime: new FormControl<number | null>(null)
        });
        return formGroup;
    }

    createPlanningRatioFormGroup(activity: PremisesGenericActivityType, ratioActivity?: GenericWorkRatioActivity) {
        const ratioItem = ratioActivity?.plannedItems?.length > 0 ? ratioActivity.plannedItems[0] : undefined;
        const formGroup = new FormGroup({
            net4ConceptId: new FormControl(activity.net4ConceptId, { nonNullable: true }),
            net4ConceptName: new FormControl(activity.net4ConceptName, { nonNullable: true }),
            displayName: new FormControl(activity.displayName, { nonNullable: true }),
            alternativeName: new FormControl(ratioActivity?.alternativeName ?? null),
            measurementType: new FormControl<PremisesMeasurementType>(activity.measurementType, { nonNullable: true }),
            planned: new FormControl<boolean | number | null>({ value: ratioItem?.ratio ?? null, disabled: true }),
            goal: new FormControl<number | null>({ value: ratioActivity?.objectiveProgress?.plannedObjectivePercentage ?? null, disabled: true }),
            minGoal: new FormControl<number | null>({ value: ratioActivity?.objectiveProgress?.plannedCoveragePercentage ?? null, disabled: true }),
            theoricRatio: new FormControl<number | null>({ value: ratioItem?.theoricRatio ?? null, disabled: true }),
            theoricTime: new FormControl<number | null>({ value: ratioItem?.theoricTime ?? null, disabled: true })
        });
        return formGroup;
    }

    createPlanningTimeFormGroup(activity: PremisesGenericActivityType, timeActivity?: GenericActivityWorktime) {
        const timeItem = timeActivity?.plannedItems?.length > 0 ? timeActivity.plannedItems[0] : undefined;
        const formGroup = new FormGroup({
            net4ConceptId: new FormControl(activity.net4ConceptId, { nonNullable: true }),
            net4ConceptName: new FormControl(activity.net4ConceptName, { nonNullable: true }),
            displayName: new FormControl(activity.displayName, { nonNullable: true }),
            alternativeName: new FormControl(timeActivity?.alternativeName ?? null),
            measurementType: new FormControl<PremisesMeasurementType>(activity.measurementType, { nonNullable: true }),
            planned: new FormControl<boolean | number | null>({ value: timeItem?.time ?? null, disabled: true }),
            goal: new FormControl<number | null>({ value: timeActivity?.objectiveProgress?.plannedObjectivePercentage ?? null, disabled: true }),
            minGoal: new FormControl<number | null>({ value: timeActivity?.objectiveProgress?.plannedCoveragePercentage ?? null, disabled: true }),
            theoricRatio: new FormControl<number | null>({ value: timeItem?.theoricRatio ?? null, disabled: true }),
            theoricTime: new FormControl<number | null>({ value: null, disabled: true })
        });
        return formGroup;
    }

    createPlanningOtherFormGroup(activity: PremisesGenericActivityType, otherActivity?: GenericOtherActivity) {
        const formGroup = new FormGroup({
            net4ConceptId: new FormControl(activity.net4ConceptId, { nonNullable: true }),
            net4ConceptName: new FormControl(activity.net4ConceptName, { nonNullable: true }),
            displayName: new FormControl(activity.displayName, { nonNullable: true }),
            alternativeName: new FormControl(otherActivity?.alternativeName ?? null),
            measurementType: new FormControl<PremisesMeasurementType>(activity.measurementType, { nonNullable: true }),
            planned: new FormControl<boolean | number | null>({ value: activity.measurementType === PremisesMeasurementType.BOOLEAN && activity.allocationScope === PremisesAllocationScope.CENTER ? otherActivity?.plannedValue === 1 : otherActivity?.plannedValue, disabled: true }),
            goal: new FormControl<number | null>({ value: null, disabled: true }),
            minGoal: new FormControl<number | null>({ value: null, disabled: true }),
            theoricRatio: new FormControl<number | null>(null),
            theoricTime: new FormControl<number | null>(null)
        });
        return formGroup;
    }

    createPlanningAutomationFormGroup(automationGroup?: GenericBillingAutomationGroup, billingAutomationGroup?: string) {
        const automationItem = automationGroup?.items?.length > 0 ? automationGroup.items[0] : undefined;
        const formGroup = new FormGroup({
            billingAutomation: new FormControl(billingAutomationGroup),
            displayName: new FormControl(billingAutomationGroup ? `${this.transloco.translate('taskList.planning.automation')} (${billingAutomationGroup}})`.toUpperCase()
                : this.transloco.translate('taskList.planning.automation').toUpperCase(), { nonNullable: true }),
            planned: new FormControl<number | null>({ value: automationItem?.time, disabled: true }),
            goal: new FormControl<number | null>({ value: automationGroup?.objectiveProgress?.plannedObjectivePercentage ?? null, disabled: true }),
            minGoal: new FormControl<number | null>({ value: automationGroup?.objectiveProgress?.plannedCoveragePercentage ?? null, disabled: true }),
        });
        return formGroup;
    }
    
    filterActivitiesForCenterPart(act: PremisesGenericActivityType[]) {
        const activities = act.filter(a => a.measurementType !== PremisesMeasurementType.NOT_APPLY);
        const activityList: PremisesGenericActivityType[] = [];
        for (const activity of activities) {
            if (activity.alternativeNames && activity.alternativeNames.length > 0) {
                for (const alternativeName of activity.alternativeNames) {
                    activityList.push({ ...activity, displayName: alternativeName });
                }
            } else {
                activityList.push({ ...activity, displayName: activity.net4ConceptName });
            }
        }
        return activityList;
    }
}